import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import ogImage from "@assets/img-decoding-asia-og.jpg";
import NoAdSettings from "@components/Advertisement/NoAdSettings";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import GAData from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import { URL_ORIGIN } from "@components/MetaTags/constants";
import MetaTags from "@components/MetaTags/MetaTags";
import { useWindowSize } from "@hooks/useWindowSize";
import Content from "@pages/Newsletter/DecodingAsia/components/Content";
import Graphic from "@pages/Newsletter/DecodingAsia/components/Graphic";
import ShareLinks from "@pages/Newsletter/DecodingAsia/components/ShareLinks/ShareLinks";
import { DecodingAsiaPageData } from "@pages/Newsletter/DecodingAsia/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * The main page component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18655-28678&m=dev
 */
const DecodingAsiaPageContent = ({
  seoFooterData,
}: DecodingAsiaPageData): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const adBlockDetected = useDetectAdBlock();

  return (
    <div data-testid="decoding-asia-page-component" className="w-full">
      <NoAdSettings />

      <MetaTags
        title="Sign up for Decoding Asia newsletter"
        description="Your guide to navigating Asia in a new global order"
        ogImageUrl={`${URL_ORIGIN}${ogImage}`}
        ogDescription="Your guide to navigating Asia in a new global order"
        ogTitle="Sign up for Decoding Asia newsletter"
        slug={RouteFactory.newslettersDecodingAsia}
      />

      <GAData
        title="Newsletter signup landing page"
        level2="newsletters"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <Header />

      <Container rootClassName="grid gap-4 grid-cols-1 lg:gap-8 lg:grid-cols-2 py-12">
        <Content />

        <Graphic />

        <>
          {!isScreenLG ? (
            <>
              <p className="mb-0 mt-8 font-poppins text-base font-normal leading-normal text-gray-850">
                Read more about Asia and beyond at The Business Times Global.
                Visit us at{" "}
                <Link
                  to="/global"
                  className="font-medium text-verticals-btblue underline"
                  target="_blank"
                >
                  bt.global
                </Link>
                .
              </p>

              <ShareLinks className="border-t border-gray-195 pt-4" />
            </>
          ) : null}
        </>
      </Container>

      <SeoFooter data={seoFooterData} />
    </div>
  );
};

export default DecodingAsiaPageContent;
